import { useEffect, useRef } from 'react';
import { Typography } from '@mui/material';

const Title = ({ autoFocus = true, text, children, ...props }) => {
  const titleRef = useRef(null);

  useEffect(() => {
    if (autoFocus && titleRef.current) {
      titleRef.current.focus();
    }
  }, [autoFocus]);

  return (
    <Typography
      ref={titleRef}
      tabIndex={0}
      variant='h1'
      component='h1'
      mb={{ xs: 2, sm: 3 }}
      fontSize={{ xs: '1.7rem', sm: '2rem' }}
      textAlign={{ xs: 'center', sm: 'left' }}
      fontWeight={600}
      {...props}
    >
      {text}
      {children}
    </Typography>
  );
};

export default Title;
